import { siteInfo } from "@/mocks/site";
import { buildWhatsAppLink } from "@/utils/whatsapp";
import Reveal from "./Reveal";

const heroImage =
  "https://storage.helloreaddy.io/project_files/c4f2c66c-1a08-4ed3-87f2-fa775eeabedc/9605c48e-f561-4841-9380-00bb818cccb8_compressed_genel_reklam.webp";

export default function Hero() {
  const waLink = buildWhatsAppLink(siteInfo.defaultMessage);

  return (
    <section id="anasayfa" className="emerald-canvas relative overflow-hidden">
      <div
        className="pointer-events-none absolute -left-24 top-24 h-72 w-72 rounded-full bg-accent-500/10 blur-3xl animate-pulse-glow"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -right-16 bottom-0 h-80 w-80 rounded-full bg-primary-400/20 blur-3xl"
        aria-hidden="true"
      />

      <div className="relative mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-14 px-5 pb-20 pt-32 md:px-6 md:pt-36 lg:grid-cols-[1.05fr_0.95fr] lg:gap-12 lg:pb-28 lg:pt-40">
        <div className="flex flex-col items-start">
          <Reveal>
            <span className="inline-flex items-center gap-2 rounded-full border border-accent-500/50 bg-primary-950/40 px-4 py-2 font-label text-[0.65rem] font-medium uppercase tracking-[0.24em] text-accent-300 md:text-xs">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-map-pin-2-line text-base" aria-hidden="true" />
              </span>
              {siteInfo.locationShort}
            </span>
          </Reveal>

          <Reveal delay={80}>
            <h1 className="mt-7 font-heading text-[2.4rem] font-semibold uppercase leading-[1.05] tracking-tight text-background-50 sm:text-[3.1rem] lg:text-[3.9rem]">
              Güzelliğinize
              <span className="mt-1 block text-gold">Profesyonel Bir Dokunuş</span>
            </h1>
          </Reveal>

          <Reveal delay={160}>
            <p className="mt-6 max-w-xl font-body text-sm leading-relaxed text-background-200 md:text-base">
              Lazer epilasyondan cilt bakımına, kalıcı makyajdan bölgesel uygulamalara kadar size özel
              bakım seçenekleri Fatma Angay Güzellik Salonu’nda.
            </p>
          </Reveal>

          <Reveal delay={240}>
            <div className="mt-9 flex w-full flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#kampanyalar"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-7 py-4 font-label text-xs font-semibold uppercase tracking-[0.16em] text-primary-950 transition-colors hover:bg-accent-400 md:text-sm"
              >
                Kampanyaları İncele
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-right-line text-base" aria-hidden="true" />
                </span>
              </a>
              <a
                href={waLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/40 px-7 py-4 font-label text-xs font-semibold uppercase tracking-[0.16em] text-background-50 transition-colors hover:border-accent-400 hover:text-accent-300 md:text-sm"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-whatsapp-line text-base" aria-hidden="true" />
                </span>
                WhatsApp’tan Randevu Al
              </a>
            </div>
          </Reveal>

          <Reveal delay={320}>
            <p className="mt-8 font-label text-[0.7rem] uppercase tracking-[0.18em] text-background-300 md:text-xs">
              Güncel kampanyalar <span className="text-accent-400">•</span> Randevulu hizmet{" "}
              <span className="text-accent-400">•</span> WhatsApp’tan hızlı bilgi
            </p>
          </Reveal>
        </div>

        <Reveal delay={200} className="w-full">
          <div className="relative mx-auto w-full max-w-md lg:max-w-none">
            <div
              className="absolute -inset-3 rounded-[2.2rem] border border-accent-500/30"
              aria-hidden="true"
            />
            <div className="relative rounded-[1.8rem] border border-accent-500/60 bg-primary-950/60 p-2.5">
              <div className="overflow-hidden rounded-[1.4rem] bg-primary-900">
                <img
                  src={heroImage}
                  alt="Fatma Angay Güzellik Salonu uygulama alanları ve hizmetleri"
                  title="Fatma Angay Güzellik Salonu Osmangazi Bursa"
                  className="h-full w-full object-contain"
                />
              </div>
            </div>
            <div
              className="pointer-events-none absolute -right-4 -top-4 flex h-16 w-16 items-center justify-center rounded-full border border-accent-400/60 bg-primary-950/80 animate-float-soft"
              aria-hidden="true"
            >
              <i className="ri-vip-diamond-line text-2xl text-accent-400" />
            </div>
          </div>
        </Reveal>
      </div>

      <div className="gold-rule" aria-hidden="true" />
    </section>
  );
}